import React from 'react';
import moment from 'moment';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import Event from './Event';

// This is the query that Apollo Client will send to the WP site.
const EVENTS_QUERY = gql`
query MyQuery($first: Int) {
	events(first: $first) {
		edges {
			node {
				title
				eventId
				event_information {
					description
					time {
						end
						start
					}
					location {
						buildingName
						roomName
						roomNumber
					}
				}
			}
		}
	}
}
`;

/*
cities.filter(e => e.population < 3000000)
      .sort((a, b) => (b.population - a.population))
	  .map(e => console.log(e.name + ':' + e.population));
	  */

//moment(edge.node.event_information.time.start).isBetween(start, end));

const EventBlock = ({start, end}) => {
	const { loading, error, data } = useQuery(EVENTS_QUERY, {
		variables: { "first": 50 },
	});

	if (loading) return 'Loading...';
	if (error) return `Error! ${error.message}`;
	
	return data.events.edges
	.filter((edge) => { 
		return moment(edge.node.event_information.time.start).isBetween(start, end, null, '[]');
	})
	.sort(function(a,b) {
        return moment(a.node.event_information.time.start) - moment(b.node.event_information.time.start);
    })
	.map((edge,key) => {
		return (
			<Event key={key} edge={edge} />
		);
	});
}

export default EventBlock;


